<template>
    <div id="customerservice">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">联系客服</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>
        <div class="info">
            <p>如您支付未到账或者出现其他问题，请及时联系本站客服帮助处理。</p>

            <p>微信号：glg318</p>

            <h4>温馨提示</h4>
            <p>1、一经购买不适用无理由退款，充值一旦成功，充值即确定完成，将不能提供任何更改，修正服务，用户不得以消费完成后账户内仍有剩余书币为由要求退款！</p>

            <p>2、充值书币可能会有延迟，充值后如一小时仍未到账，请及时联系客服处理。</p>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Customerservice"
    }
</script>

<style lang="less">
    #customerservice{overflow: hidden;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        .info{padding: 20px;
            p{font-size: 28px;margin-bottom: 50px;color: #666;}
        }
    }
</style>
